import { render, staticRenderFns } from "./QcCallsReport.vue?vue&type=template&id=139fbfc8&scoped=true&"
import script from "./QcCallsReport.vue?vue&type=script&lang=js&"
export * from "./QcCallsReport.vue?vue&type=script&lang=js&"
import style0 from "./QcCallsReport.vue?vue&type=style&index=0&id=139fbfc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139fbfc8",
  null
  
)

export default component.exports